import { hasProp } from "../../../helpers/Class";
import Country from "../Country";
import CarrierArea from "./CarrierArea";
import Carrier from "./Carrier";
import CarrierDestinationPrice from "./CarrierDestinationPrice";
import i18n from "../../../i18n";

class CarrierDestination {
    constructor(destination = null) {
        this.id = !hasProp(destination, "id") ? undefined : destination.id;
        this.carrierId = !hasProp(destination, "carrierId") ? undefined : destination.carrierId;
        this.carrierAreaId = !hasProp(destination, "carrierAreaId") ? null : destination.carrierAreaId;
        this.countryId = !hasProp(destination, "countryId") ? undefined : destination.countryId;
        this.minDeliveryDays = !hasProp(destination, "minDeliveryDays") ? null : destination.minDeliveryDays;
        this.maxDeliveryDays = !hasProp(destination, "maxDeliveryDays") ? null : destination.maxDeliveryDays;
        this.fixedTaxPercent = !hasProp(destination, "fixedTaxPercent") ? null : destination.fixedTaxPercent;
        this.country = !hasProp(destination, "country") ? new Country() : new Country(destination.country);
        this.area = !hasProp(destination, "area") ? new CarrierArea() : new CarrierArea(destination.area);
        this.carrier = !hasProp(destination, "carrier") ? new Carrier() : new Carrier(destination.carrier);

        this.prices = [];
        if (destination !== null && destination.prices) {
            this.prices = destination.prices.map(price => new CarrierDestinationPrice(price));
        }
    }

    sanitizeForAPI() {
        if (this.minDeliveryDays !== undefined && typeof this.minDeliveryDays !== "number" &&
            (this.minDeliveryDays === null || this.minDeliveryDays.trim() === "")) {
            this.minDeliveryDays = null;
        }
        if (this.maxDeliveryDays !== undefined && typeof this.maxDeliveryDays !== "number" &&
            (this.maxDeliveryDays === null || this.maxDeliveryDays.trim() === "")) {
            this.maxDeliveryDays = null;
        }
        if (this.fixedTaxPercent !== undefined && typeof this.fixedTaxPercent !== "number" &&
            (this.fixedTaxPercent === null || this.fixedTaxPercent.trim() === "")) {
            this.fixedTaxPercent = null;
        }
    }

    minDeliveryDaysLabel() {
        if (this.minDeliveryDays === null) {
            return i18n.t("CarrierDestinationClass.notDefined");
        }
        return `${this.minDeliveryDays} ${i18n.tc("CarrierDestinationClass.days", this.minDeliveryDays)}`;
    }

    maxDeliveryDaysLabel() {
        if (this.maxDeliveryDays === null) {
            return i18n.t("CarrierDestinationClass.notDefined");
        }
        return `${this.maxDeliveryDays} ${i18n.tc("CarrierDestinationClass.days", this.maxDeliveryDays)}`;
    }

    fixedTaxPercentLabel() {
        if (this.fixedTaxPercent === null) {
            return i18n.t("CarrierDestinationClass.notDefined");
        }
        return `${this.fixedTaxPercent} %`;
    }
}

export default CarrierDestination;